import GenericAjaxService from './GenericAjaxService';
import {publicAPI, privateAPI} from './api';

export default class NotificationService extends GenericAjaxService {

    static getNotifications(opts) {
        return super.getAPI(publicAPI, `notifications`, opts);
    }

    static getIncompleteProfileNotification(opts) {
        return super.getAPI(privateAPI, `notifications/getIncompleteProfileNotification`, opts);
    }
}